import { Rating as SMRating, Star } from '@smastrom/react-rating';
import '@smastrom/react-rating/style.css';
import { FC } from 'react';

type RatingProps = React.ComponentProps<typeof SMRating>;

const defaultItemStyles = {
    itemShapes: Star,
    activeFillColor: '#FFAE55',
    inactiveFillColor: '#FFE2BD'
};

const defaultStyle: React.CSSProperties = {
    direction: 'ltr'
};

const Rating: FC<RatingProps> = ({ itemStyles, style, readOnly = true, halfFillMode = 'svg', ...props }) => {
    return (
        <SMRating
            {...props}
            readOnly={readOnly}
            halfFillMode={halfFillMode}
            itemStyles={{ ...defaultItemStyles, ...itemStyles }}
            style={{ ...defaultStyle, ...style }}
        />
    );
};

export default Rating;

